  //Convert Unix to date

  //const moment = require("moment");
  const moment = require("moment-timezone");

  // const date={

  //  getDate(unixtime){
    
  //   var date = moment.unix(unixtime).add(1,'days');
  //   var formattedTime= date.format("MM/DD/YYYY");
  //   // Create a new JavaScript Date object based on the timestamp
  //   // multiplied by 1000 so that the argument is in milliseconds, not seconds.

  //   return formattedTime;
  //       }
  // }

  const date = {
    getDate(input) {
      let date;
      let timezone;
  
      try {
        // Detect user's system timezone (e.g., "Asia/Kolkata", "America/New_York")
        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      } catch (err) {
        // Fallback if timezone detection fails
        timezone = "UTC";
      }
  
      if (input < 10000000000) {
        // Days since epoch (like 20291)
        date = moment.tz("1970-01-01", timezone).add(input, 'days');
      } else if (input < 10000000000000) {
        // Seconds since epoch
        date = moment.unix(input).tz(timezone);
      } else {
        // Milliseconds since epoch
        date = moment(input).tz(timezone);
      }
  
      return date.format("MM/DD/YYYY");
    }
  };
  
  module.exports = date;